import { evolve, has, is, map } from "ramda";
import { hasPropOrPath } from "../../packages/core/toolbox/objects";
import { hasAnyProp, findFirstValueDefined } from '@dirootie-toolbox/objects';
import { ComponentProps } from "./types/props";
export type Component<T = any> = {component: T} | T;
export type PropOrValue<PropName extends string, T> = { [K in PropName]: T } | T;

export const getProps = <T extends any>(obj: ComponentProps<T>):T =>
  hasAnyProp(["props","component.props"])(obj) ? findFirstValueDefined<T>(["props","component.props"],obj as any,undefined as any) as any : obj;

export const getComponent = <T extends any>(obj: PropOrValue<"component",T>):T =>
  hasAnyProp(["component"])(obj) ? findFirstValueDefined<T>(["component"],obj as any,undefined as any) as any : obj;

export const traverseAndModify = <T>(obj: any,modifyProps: (x:any) => any): any => {
  return map(
    (value:any) => {
      if (is(Object, value)) {
        if (has('props', value)) {
          return evolve({ props: modifyProps }, value);
        } else {
          return traverseAndModify(value, modifyProps);
        }
      }
      return value;
    },
    obj
  );
};
